module.exports = __webpack_public_path__ + "img/promotion-background.a52d0ed1.jpg";